export default __webpack_public_path__ + "static/media/hotel.1eab3779.png";